import {MapContainer, Marker, Popup, TileLayer} from "react-leaflet";
import React from "react";

export const LeafletMap = ({latitude, longitude}) => {
    return (
        <MapContainer
            center={[latitude, longitude]}
            zoom={16}
            style={{
                // width: "100%",
                height: 300,
                borderRadius: '0.5rem'
            }}>
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />
            <Marker position={[latitude, longitude]}>
                <Popup>Vị trí của bạn</Popup>
            </Marker>
        </MapContainer>
    );
};